module.exports = __webpack_public_path__ + "/images/constructor-hiw.generic.b520126.png";